// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2pMdr","head":"Table_head__-suA4","col":"Table_col__AD8a6"};